module.exports = __webpack_public_path__ + "static/media/pdf-icon.9e5ad0f1.svg";